import moment from 'moment';

export const isInProgress = (absence) => {
  const startDate = moment.utc(Number(absence.startDate));
  const endDate = moment.utc(Number(absence.endDate));
  const now = moment();

  return startDate.isSameOrBefore(now) && now.isBefore(endDate);
}